import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { useFieldArray } from 'react-final-form-arrays';
import { Pager, Well } from 'react-bootstrap';
import ResultsPaginator from '../../components/advancedSearch/results/ResultsPaginator';

const LOCAL_STORAGE_ITEMSPERPAGE_KEY = 'PagedFieldArray.itemsPerPage';

export default function PagedFieldArray({ name, item: ItemComponent, after: AfterComponent }) {
  const [page, gotoPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(localStorage.getItem(LOCAL_STORAGE_ITEMSPERPAGE_KEY) || 15);
  const topOfPage = useRef(null);
  const { fields } = useFieldArray(name, { subscription: {} });
  const totalPages = Math.ceil(fields.length / itemsPerPage);

  useLayoutEffect(() => {
    if (topOfPage.current) topOfPage.current.scrollIntoView({ behavior: 'smooth' });
  }, [page]);

  useEffect(() => {
    localStorage.setItem(LOCAL_STORAGE_ITEMSPERPAGE_KEY, itemsPerPage);
  }, [itemsPerPage]);

  function Pager() {
    if (totalPages === 0) return null;
    return (
      <div>
        <Well>
          <div style={{ float: 'left' }}>
            <strong>
              Records {(page - 1) * itemsPerPage + 1} - {Math.min(page * itemsPerPage, fields.length)} of{' '}
              {fields.length}
            </strong>
          </div>
          <div style={{ float: 'left', marginLeft: 24 }}>
            Show{' '}
            <select
              onChange={(e) => {
                setItemsPerPage(e.target.value);
                gotoPage(1);
              }}
              value={itemsPerPage}
            >
              <option value={1}>1</option>
              <option value={5}>5</option>
              <option value={10}>10</option>
              <option value={15}>15</option>
              <option value={20}>20</option>
              <option value={25}>25</option>
              <option value={50}>50</option>
            </select>{' '}
            records per page
          </div>
          <div style={{ float: 'right', marginTop: -9 }}>
            <ResultsPaginator totalPages={totalPages} selectedPage={page} onChangePage={(page) => gotoPage(page + 1)} />
          </div>
        </Well>
      </div>
    );
  }

  return (
    <React.Fragment>
      <div ref={topOfPage} />
      <Pager />
      {fields.map((name, index) =>
        page * itemsPerPage > index && index >= (page - 1) * itemsPerPage ? (
          <ItemComponent key={name} {...{ name, index, fields }} />
        ) : null
      )}
      {(page === totalPages || totalPages === 0) && AfterComponent && <AfterComponent />}
      <Pager />
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/scheduleform/common/PagedFieldArray.jsx